import React from 'react';
import { getGlobalStyleSheet } from '@usealloy/component-library';
import { createGlobalStyle } from 'styled-components';

import { themes } from '~/dashboard/ThemeProvider/constants';
import type { Themes } from '~/dashboard/ThemeProvider/constants';


type Props = {
  theme?: Themes;
};

/** This function exports a GlobalStyle component which injects to the :root our
  * design tokens. getGlobalStyleSheet returns a our design tokens in a string
  * format. It is then passed into createGlobalStyle function from
  * styled-components to create this component.
  */
export default function GlobalStyle(props: Props) {
  const { theme = themes.light } = props;
  const globalStyles = getGlobalStyleSheet(theme);
  const GlobalStyleComponent = createGlobalStyle`${globalStyles}`;

  return <GlobalStyleComponent />;
}
